import { SkeletonLoader, TableCell } from '@design';
import React, { CSSProperties } from 'react';

import styles from './LoaderCell.module.scss';

export const LoaderCell = ({ numberOfRows }: { numberOfRows: number }) => {
  return (
    <>
      {Array.from({ length: numberOfRows }).map((_, index) => {
        return (
          <tr key={`tr-${index}`} style={{ width: '100%' }}>
            <TableCell alignment="left">
              <div className={styles.rankLoaderWrapper}>
                <SkeletonLoader
                  areas={[
                    {
                      styles: {
                        width: '100%',
                        height: '24px',
                        borderRadius: '8px',
                      },
                    },
                  ]}
                />
              </div>
            </TableCell>
            <TableCell alignment="left">
              <div className={styles.flexRow}>
                <div className={styles.logoLoaderWrapper}>
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '32px',
                          borderRadius: '40px',
                        },
                      },
                    ]}
                  />
                </div>
                <div
                  className={styles.themeNameLoaderWrapper}
                  style={
                    {
                      '--loader-width': `${114 + index * 30}px`,
                    } as CSSProperties
                  }
                >
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '24px',
                          borderRadius: '8px',
                        },
                      },
                    ]}
                  />
                </div>
              </div>
            </TableCell>
            <TableCell alignment="left">
              <div className={styles.descriptionLoaderWrapper}>
                <SkeletonLoader
                  areas={[
                    {
                      styles: {
                        width: '100%',
                        height: '12px',
                        borderRadius: '8px',
                      },
                    },
                  ]}
                />
              </div>
            </TableCell>
          </tr>
        );
      })}
    </>
  );
};
